import React, { createContext, useCallback, useContext, useState } from 'react';

import { OrchestratorAgentService } from '../services/llmClient/OrchestratorAgentService';
import { executeOrchestratorCommands } from '../services/llmClient/OrchestratorCommandExecutor';

const OrchestratorAgentContext = createContext(null);

export function OrchestratorAgentProvider({
  userId,
  navigate,
  focusTask,
  getAppContext,
  children,
}) {
  const [isBusy, setIsBusy] = useState(false);

  const sendToAgent = useCallback(
    async (message) => {
      if (!userId || !message) return { reply: '', commands: [] };

      setIsBusy(true);
      try {
        const appContext = typeof getAppContext === 'function' ? getAppContext() : {};

        const { reply, commands } = await OrchestratorAgentService.sendInstruction({
          userId,
          message,
          appContext,
        });

        await executeOrchestratorCommands(commands, {
          navigate,
          focusTask,
        });

        return { reply, commands };
      } finally {
        setIsBusy(false);
      }
    },
    [userId, navigate, focusTask, getAppContext]
  );

  const value = {
    sendToAgent,
    isBusy,
  };

  return (
    <OrchestratorAgentContext.Provider value={value}>{children}</OrchestratorAgentContext.Provider>
  );
}

export function useOrchestratorAgent() {
  const ctx = useContext(OrchestratorAgentContext);
  if (!ctx) {
    throw new Error('useOrchestratorAgent must be used within an OrchestratorAgentProvider');
  }
  return ctx;
}

export default OrchestratorAgentContext;
